class CompareAtPrice {
    constructor() {
        this.selector = {
            productHandles: document.querySelectorAll('[data-compare-at-price="true"]')
        };
        this.state = {
            handles: [],
            products: [],
            discountByCollection: [],
            discountByProductTags: [],
            accessToken: 'ab26483f310b575656074dc4388a9cde'
        };
    }

    static async load(instance) {
        if (!instance) {
            console.error("CompareAtPrice.load() requires an instance of the class.");
            return;
        }

        instance.state.handles = Array.from(instance.selector.productHandles, el => el.dataset.handle);
        if (instance.state.handles.length > 0) {
            const productQuery = instance.generateProductQuery(instance.state.handles);
            await instance.extract(productQuery);
        }
    }

    async extract(productQuery) {
        const query = `{
            discountByCollection: metaobjects(type: "compare_at_price_discount", first: 20) {
                nodes { fields { key value } }
            }
            discountByProductTags: metaobjects(type: "compare_at_price_discount_by_product_tag", first: 20) {
                nodes { fields { key value } }
            }
            ${productQuery}
        }`;

        try {
            const response = await fetch('/api/2025-01/graphql.json', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': this.state.accessToken,
                },
                body: JSON.stringify({ query })
            });
            const results = await response.json();
            
            this.processResults(results.data);
        } catch (error) {
            console.error('Error fetching metaobjects:', error);
        }
    }

    processResults(data) {
        Object.keys(data).forEach(key => {
            if (key.startsWith('product')) {
                this.state.products.push(data[key]);
            }
        });

        this.state.discountByCollection = data?.discountByCollection?.nodes || [];
        this.state.discountByProductTags = data?.discountByProductTags?.nodes || [];

        this.applyDiscounts();
    }

    applyDiscounts() {
        this.state.products.forEach(product => {
            product?.collections?.nodes.forEach(col => {
                this.state.discountByCollection.some(item => {
                    const filterField = item.fields.find(field => field.key === 'filter_by_collection' && field.value === col.collection_handle);
                    if (!filterField) return false;

                    let { discountedAmount, currencyCode, discountPercentageValue, discountFixedAmount} = this.calculateDiscount(product, item.fields);
                    
                    this.updateDOM(product, discountedAmount, currencyCode, discountPercentageValue, discountFixedAmount);
                    return true; // Break the loop once a match is found
                });
            });

            product?.product_tags.forEach(tag => {
                this.state.discountByProductTags.some(item => {
                    const filterField = item.fields.find(field => field.key === 'filter_by_product_tag' && field.value === tag);
                    if (!filterField) return false;

                    let { discountedAmount, currencyCode, discountPercentageValue, discountFixedAmount } = this.calculateDiscount(product, item.fields);
                    
                    this.updateDOM(product, discountedAmount, currencyCode, discountPercentageValue, discountFixedAmount);
                    return true; // Break the loop once a match is found
                });
            });
        });
    }

    calculateDiscount(product, fields) {
        const elementFound = document.querySelector(`[data-compare-at-price="true"][data-handle="${product.handle}"]`);
        let variantSelectedId = elementFound.dataset.selectedVariant;
        let variantSelectedPrice = parseFloat(product.variants.nodes[0].price.amount);
        if(product.variants.nodes.length > 0) {
            product.variants.nodes.forEach(node => {
                const variantId = node.id.replace('gid://shopify/ProductVariant/', '');
                if(parseInt(variantSelectedId) === parseInt(variantId)) {
                    variantSelectedPrice = parseInt(node.price.amount);      
                    if(elementFound) {
                        const regularPriceEl = elementFound.closest('.discounted-price').querySelector('[data-product-current-price="true"]');
                        const variantCurrencyCode = node.price.currencyCode;                
                        let formattedRegularPrice = new Intl.NumberFormat('en-US', { style: 'currency', currency: variantCurrencyCode, maximumFractionDigits: 0 }).format(parseFloat(variantSelectedPrice));      
                        regularPriceEl.textContent = formattedRegularPrice;
                    }
                }
            })
        }
        const priceAmount = variantSelectedPrice;
        let discountType = 'percentage';
        let discountPercentageValue = 0;
        let discountFixedAmount = 0;
        let currencyCode = 'USD';
   
        fields.forEach(field => {
            if (field.key === 'discount_type' && field.value === "false") {
                discountType = 'fixed';
            } else if (field.key === 'discount_percentage') {
                discountPercentageValue = parseInt(field.value);
            } else if (field.key === 'discount_fixed_amount') {
                const jsonAmount = JSON.parse(field.value);
                discountFixedAmount = parseFloat(jsonAmount.amount);
                currencyCode = jsonAmount.currency_code;
            }
        });

        let discountedAmount = (discountType === 'percentage')
            ? priceAmount * (1 - discountPercentageValue * 0.01)
            : priceAmount - discountFixedAmount;

        return { discountedAmount, currencyCode, discountFixedAmount, discountPercentageValue };
    }

    updateDOM(product, discountedAmount, currencyCode, discountPercentageValue, discountFixedAmount) {
        const elementFound = document.querySelector(`[data-compare-at-price="true"][data-handle="${product.handle}"]`);
        let variantSelectedId = elementFound.dataset.selectedVariant;
        let variantSelectedPrice = parseFloat(product.variants.nodes[0].price.amount);
        if(product.variants.nodes.length > 0) {
            product.variants.nodes.forEach(node => {
                const variantId = node.id.replace('gid://shopify/ProductVariant/', '');
                if(parseInt(variantSelectedId) === parseInt(variantId)) {
                    variantSelectedPrice = parseInt(node.price.amount);   
                }
            })
        }
        if (!elementFound) return;

        if (discountedAmount < parseFloat(variantSelectedPrice)) {
            const formattedPrice = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: currencyCode,
                maximumFractionDigits: 0
            }).format(discountedAmount);

            const formattedSavePrice = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: currencyCode,
                maximumFractionDigits: 0
            }).format(parseFloat(variantSelectedPrice) - discountedAmount);

            elementFound.classList.remove('hide');

            elementFound.textContent = formattedPrice;

          
            let formattedDiscountFixedAmount = discountFixedAmount > 0 
                ? new Intl.NumberFormat('en-US', { style: 'currency', currency: currencyCode, maximumFractionDigits: 0 }).format(parseFloat(discountFixedAmount))
                : null;

            const compareAtPriceElement = elementFound.closest('.discounted-price') 
                ? elementFound.closest('.discounted-price').querySelector('.product-price--current') 
                : null;

            if (compareAtPriceElement) compareAtPriceElement.classList.add('product-price--compare');

            const savedElement = elementFound.closest('.discounted-price') 
                ? elementFound.closest('.discounted-price').querySelector('.product__price-savings') 
                : null;
        
            if (savedElement) {
                savedElement.textContent = `SAVE ${formattedSavePrice} (${discountPercentageValue > 0 ? discountPercentageValue+'%' : formattedDiscountFixedAmount})`;
                savedElement.classList.remove('hide');
            }
        } else {
            const savedElement = elementFound.closest('.discounted-price') 
                ? elementFound.closest('.discounted-price').querySelector('.product__price-savings') 
                : null;   
            elementFound.classList.add('hide');
            if (savedElement) savedElement.classList.add('hide');
        }
        const swatchImage = document.querySelector('swatch-image');
        if(swatchImage) {
            swatchImage.dataset.discountPercentageValue = discountPercentageValue;
            swatchImage.dataset.discountFixedAmount = discountFixedAmount;
            swatchImage.dataset.currencyCode = currencyCode;
        }
    }

    generateProductQuery(handles) {
        return handles.map((handle, index) => `
            product${index}: product(handle: "${handle}") {
                title
                handle
                variants(first:20) {
                    nodes { 
                        price { amount currencyCode } 
                        id
                    }
                }
                collections(first: 50) { nodes { collection_handle: handle } }
                product_tags: tags
            }
        `).join('\n');
    }
}


const compareAtPriceInstance = new CompareAtPrice();

CompareAtPrice.load(compareAtPriceInstance);
